 // [module, appId]
export type RoleInfo = [string, string];
export type RoleList = {[key: string]: RoleInfo };

export interface update {
	/**
	 * 更新角色列表，会将原有角色设置移除
	 * @param data 新的角色列表
	 */
	(data: RoleList): void;
};
export interface set {
	/**
	 * 设置路由角色
	 * @param role     角色
	 * @param module   模块
	 * @param appId    所属应用Id
	 */
	(role: string, module: string, appId?: string): void;
}
export interface remove {
	/**
	 * 移除角色
	 * @param role   角色
	 */
	(role: string): void;
}
export interface get {
	/**
	 * 获取角色信息
	 * @param role   角色
	 */
	(role: string): RoleInfo | undefined;
}
export interface list {
	/**
	 * 获取角色列表
	 */
	(): RoleList;
}

export const base: RoleList = Object.create(null);

/**
 * 更新角色列表，会将原有角色设置移除
 * @param data 新的角色列表
 */
export function update(this: void | RoleList, data: RoleList): void {
	if (!(data && typeof data === 'object' && !Array.isArray(data))) { return ; }
	const roles = this || base;
	Object.keys(roles).forEach(role => delete roles[role]);
	for (let role in data) {
		const item = data[role];
		if (!Array.isArray(item)) { continue; }
		const [module, appId] = item;
		if (typeof module !== 'string') { continue; }
		roles[role] = [module, typeof appId === 'string' ? appId : ''];
	}
}
/**
 * 设置路由角色
 * @param role     角色
 * @param module   模块
 * @param appId    所属应用Id
 */
export function set(this: void | RoleList, role: string, module: string, appId?: string): void {
	const roles = this || base;
	if (typeof role !== 'string') { return; }
	if (typeof module !== 'string') { return; }
	roles[role] = [module, typeof appId === 'string' ? appId : ''];
}

/**
 * 移除路径
 * @param role   角色
 */
export function remove(this: void | RoleList, role: string): void {
	const roles = this || base;
	if (typeof role !== 'string') { return; }
	delete roles[role];
}
/**
 * 获取角色信息
 * @param role   角色
 */
export function get(this: void | RoleList, role: string): RoleInfo | undefined {
	const roles = this || base;
	if (typeof role !== 'string') { return; }
	const data = roles[role];
	if (data) {
		return Array.from(data) as RoleInfo;
	}
}
/**
 * 获取角色列表
 */
export function list(this: void | RoleList): RoleList {
	const roles = this || base;
	const ret: RoleList = {};
	for (let role in roles) {
		ret[role] = Array.from(roles[role]) as RoleInfo;
	}
	return ret;
}


interface RoleApi {
	/** 更新角色列表，会将原有角色设置移除 */
	update: update,
	/** 设置路由角色 */
	set: set,
	/** 移除角色 */
	remove: remove,
	/** 获取角色信息 */
	get: get,
	/** 获取角色列表 */
	list: list,
};
/**
 * 创建角色API
 * @param roles   列表
 */
function RoleApi(roles: RoleList = Object.create(null)): RoleApi {
	return {
		set: set.bind(roles),
		remove: remove.bind(roles),
		get: get.bind(roles),
		list: list.bind(roles),
		update: update.bind(roles),
	}
}
export type api = RoleApi;
export default RoleApi;
